module.exports = __webpack_public_path__ + "media/images/analytics_icons/analytic_cost-348c86bb56a0c417678428747d32a9d1.png";